import { render, staticRenderFns } from "./ClientsKpiCard.vue?vue&type=template&id=dce8ff90&scoped=true"
import script from "./ClientsKpiCard.vue?vue&type=script&lang=js"
export * from "./ClientsKpiCard.vue?vue&type=script&lang=js"
import style0 from "./ClientsKpiCard.vue?vue&type=style&index=0&id=dce8ff90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce8ff90",
  null
  
)

export default component.exports